import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
export const FormFieldWrapper = ({ label, width, children }) => {
    return (
        <Stack
            direction="column"
            spacing={0}
            sx={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: width
            }}
        >
            <Typography>{label} <span className="form_required">*</span></Typography>
            {children}
        </Stack>
    );
};